import axios from 'axios'

export const hookService = {
  getAllHooks: () => axios.get('/hooks'),
  getHookById: (id) => axios.get(`/hooks/${id}`),
  getHookDetails: (id) => axios.get(`/hooks/details/${id}`),
  getHookEvents: (id, pageNumber, pageSize) =>
    axios.get(`/hooks/details/${id}/events?pageNumber=${pageNumber}&pageSize=${pageSize}`),
  // Eventos de webhook enviados para uma ordem (do mais novo para o mais antigo).
  // beforeId: paginação, vem de nextBeforeId da resposta anterior.
  getWorkOrderEvents: (workOrderId, beforeId, pageSize = 20) =>
    axios.get(`/hooks/workOrder/${workOrderId}/events`, {
      params: { pageSize, ...(beforeId ? { beforeId } : {}) },
    }),
  // Riscos do planejamento (webhook de e-mail): prévia e envio na hora
  previewPlanningRisks: (id) => axios.get(`/hooks/${id}/planning-risks/preview`),
  sendPlanningRisks: (id) => axios.post(`/hooks/${id}/planning-risks/send`),
  // testar envio com a configuração do formulário (antes ou depois de salvar); não fica nos envios
  testPlanningRisks: (config) => axios.post('/hooks/planning-risks/test', config),
  // Reenvia um envio que falhou (mesmo conteúdo). Cada envio só pode ser reenviado uma vez.
  retryEvent: (eventId) => axios.post(`/hooks/events/${eventId}/retry`),
  createHook: (hook) => axios.post('/hooks', hook),
  updateHook: (id, hook) => axios.put(`/hooks/${id}`, hook),
  deleteHook: (id) => axios.delete(`/hooks/${id}`),
  toggleHookStatus: (id, isActive) => axios.patch(`/hooks/${id}/toggle?isActive=${!isActive}`),
}
